import { DictionariesService } from "@sa/rep-mdm";
import { orderBy } from "lodash";
import { getDateWithoutFrequency, getDateId } from "./dateHelpers";
import { MIN_DATE } from "../constants";
import { SLIDE_NUMBER } from "../constants";

export async function getCalendarMark(
  dictionariesService: DictionariesService,
  commodity: number,
  selectedYear: number | undefined,
) {
  const lastYearCalendar = await dictionariesService.getDictionary({
    id: "slides-f-last-calendar",
    parameters: {
      commodities: commodity ? String(commodity) : "201",
      slide: SLIDE_NUMBER,
    },
  });
  const calendar = await dictionariesService.getDictionary({ id: "calendar-origin", parameters: {} });

  const lastYearCalendarItems = await lastYearCalendar.getAll();
  const calendarItems = await calendar.getAll();
  const lastYearCalendarItemsSorted = orderBy(lastYearCalendarItems || [], (item) => item.getValue<number>("order"));

  const minDate = getDateWithoutFrequency(selectedYear || MIN_DATE);
  const maxDate = lastYearCalendarItemsSorted[1]
    ? getDateWithoutFrequency(lastYearCalendarItemsSorted[1].id)
    : getDateWithoutFrequency(getDateId(new Date(), 1)) + 30000;

  const calendarMark = (calendarItems || [])
    .filter((item) => item.getValue<number>("frequencyId") === 1)
    .filter((item) => minDate <= getDateWithoutFrequency(item.id) && getDateWithoutFrequency(item.id) <= maxDate)
    .map((item) => Number(item.id))
    .sort((a, b) => getDateWithoutFrequency(a) - getDateWithoutFrequency(b));

  return {
    calendar: calendarMark,
  };
}
